import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=a896a4be&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=a896a4be&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a896a4be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a896a4be')) {
      api.createRecord('a896a4be', component.options)
    } else {
      api.reload('a896a4be', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=a896a4be&scoped=true", function () {
      api.rerender('a896a4be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/investments/fee-schedule-list-manager/Index.vue"
export default component.exports